import { createSlice } from '@reduxjs/toolkit';
import { WebhookHistoryStateType } from 'src/types/webhookHistory';

const initialState: WebhookHistoryStateType = {
    data: null,
    loading: false,
    error: false,
};

export const webhookHistorySlice = createSlice({
    name: 'webhookHistory',
    initialState,
    reducers: {
        getWebhookHistoryFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getWebhookHistoryFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getWebhookHistoryFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearWebhookHistory: () => initialState,
    },
});

export const {
    getWebhookHistoryFetch,
    getWebhookHistoryFetchSuccess,
    getWebhookHistoryFetchFailure,
    clearWebhookHistory,
} = webhookHistorySlice.actions;

export default webhookHistorySlice.reducer;
